import React from "react";
import "./style.css";

// Simple SVG icon components
const LocationIcon = ({ className = "w-5 h-5" }) => (
  <svg
    className={className}
    fill="none"
    stroke="#fe7c0b"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 21s-6-5.686-6-10A6 6 0 1 1 18 11c0 4.314-6 10-6 10z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="11" r="2.5" fill="#fe7c0b" />
  </svg>
);

const EmailIcon = ({ className = "w-5 h-5" }) => (
  <svg
    className={className}
    fill="none"
    stroke="#fe7c0b"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 7l9 6 9-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PhoneIcon = ({ className = "w-5 h-5" }) => (
  <svg
    className={className}
    fill="none"
    stroke="#fe7c0b"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path
      d="M22 16.92v2a2 2 0 0 1-2.18 2A19.72 19.72 0 0 1 3.09 5.18 2 2 0 0 1 5.11 3h2a2 2 0 0 1 2 1.72c.13.81.36 1.6.68 2.34a2 2 0 0 1-.45 2.11l-.27.27a16 16 0 0 0 6.29 6.29l.27-.27a2 2 0 0 1 2.11-.45c.74.32 1.53.55 2.34.68A2 2 0 0 1 22 16.92z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ClockIcon = ({ className = "w-5 h-5" }) => (
  <svg
    className={className}
    fill="none"
    stroke="#fe7c0b"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const locations = [
  {
    title: "Main Office",
    address: "91, Sector 44, Gurugram, Haryana 122003",
    email: "contactus@acrossassist.com",
    phone: "+91 94512 86746",
    type: "office",
  },
  {
    title: "CP Delhi Office",
    address: "B-309, Statesman House, Barakhamba Road, Connaught Place, New Delhi 110001",
    email: "contactus@acrossassist.com",
    phone: "+91 94512 86745",
    type: "office",
  },
  {
    title: "Mumbai Office",
    address: "8th Floor, B-Wing, Lotus Corporate Park, Off Western Express Highway, Goregaon (East), Mumbai 400063",
    email: "contactus@acrossassist.com",
    phone: "+91 94512 86749",
    type: "office",
  },


];

const Card = ({ data }) => {
  if (data.type === "info") {
    return (
      <div className="location-card p-4 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col">
        <div className="mb-2">
          <span className="inline-block text-xs px-3 py-1 rounded-full tracking-wide shadow-sm border border-[#e0e7ef] bg-[#f7f7fa]  contact-cards-heading">
            {data.title}
          </span>
        </div>
        <h2 className="text-lg font-bold mb-2">{data.subtitle}</h2>
        <p className="text-gray-600 text-sm">{data.description}</p>
      </div>
    );
  }
  if (data.type === "office") {
    return (
      <div className="location-card p-4 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col">
        <h2 className="text-lg font-bold mb-2 flex items-center gap-2">
          <LocationIcon className="w-6 h-6 mr-1" />
          {data.title}
        </h2>
        <div className="h-[2px] w-10 bg-[#fe7c0b] mb-3 rounded"></div>
        <div className="text-gray-700 mb-2 flex items-start gap-2">
          <LocationIcon className="w-5 h-5 mt-0.5 flex-shrink-0" />
          <span>{data.address}</span>
        </div>
        <div className="flex flex-col gap-1 mt-2">
          <a
            href={`mailto:${data.email}`}
            className="flex items-center gap-2 text-[#fe7c0b] hover:underline text-sm"
          >
            <EmailIcon className="w-5 h-5" />
            {data.email}
          </a>
          <a
            href={`tel:${data.phone.replace(/[^+\d]/g, "")}`}
            className="flex items-center gap-2 text-[#183153] hover:underline text-sm"
          >
            <PhoneIcon className="w-5 h-5" />
            {data.phone}
          </a>
        </div>
      </div>
    );
  }
  if (data.type === "hours") {
    return (
      <div className="location-card p-4 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col">
        <h2 className="text-lg font-bold mb-2 flex items-center gap-2">
          <ClockIcon className="w-6 h-6 mr-1" />
          {data.title}
        </h2>
        <div className="h-[2px] w-10 bg-[#fe7c0b] mb-3 rounded"></div>
        <ul className="text-gray-700 text-sm space-y-1">
          {data.times.map((t, idx) => (
            <li key={idx} className="flex items-center gap-2">
              <ClockIcon className="w-5 h-5 flex-shrink-0" />
              <span className="font-semibold">{t.label}:</span>
              <span>{t.value}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
  return null;
};

const LocationsCards = () => {
  return (
    <div className="w-full flex justify-center my-12">
      <div className="max-w-screen-xl w-full">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-4 md:px-0 py-8">
          {locations.map((loc, idx) => (
            <Card key={idx} data={loc} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LocationsCards;
